/*
    模块组件
    ChenYN

    说明
    主页底部切换栏

    版本
    1.0

    传参
        game Object : 必填 游戏信息
            game : {
                "game_id": 88888888, // 游戏ID
                "name": "武易传奇", // 游戏名称
                "icon": "http://9377gamebox.oss-cn-beijing.aliyuncs.com/wzbyxxl.jpg", // 图标
                "badge": "http://9377gamebox.oss-cn-beijing.aliyuncs.com/icon_tag_back.png", // 勋章
                "tag": [
                    "传奇",
                    "经典",
                    "激情"
                ]
            }
        type String : 非必填 显示模式 type = recom 推荐
    依赖
    /style/2019/h5/css/common.css
    vue.js

    案例
    <demo></demo>
*/
<template>
    <div class="game_grid" :class="{only_game :type == 'recom'}">
        <img class="icon" :src="game.icon" alt="">
        <div class="name_badge" v-if="type != 'recom'"> <span class="name van-ellipsis">{{game.name}}</span> <!--<img v-if="game.badge" class="badge" :src="game.badge"> --></div>
        <div class="name_badge only_name van-multi-ellipsis--l2" v-else> {{game.name}} </div>
        <div class="tag_wrap van-ellipsis" v-if="type != 'recom'">
            <span v-for="(v,i) in game.tag" :key="i">{{v}}</span>
        </div>
    </div>
</template>

<script lang="js">
import { defineComponent, reactive, toRefs, onMounted, } from 'vue';

export default defineComponent({
    name: 'GameGrid',
    props: {
        game: {
            type: Object
        },
        type: {
            type: String,
            default: 'default'
        }
    },
    setup(props) {
        const state = reactive({});
        const data = reactive({});
        const methods = {}; //需要对外暴露的方法

        onMounted(() => {
        });

        return {
            ...toRefs(state),
            ...toRefs(data),
            ...methods
        };
    },
});
</script>
<style lang="less" scoped>
@charset "utf-8";
@import "./GameGrid.less";
</style>